import * as React from 'react'

export const Phone = () => (
  <svg
    width="70"
    height="70"
    viewBox="0 0 70 70"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_439_15926)">
      <path
        d="M55.8496 4.1207V65.8793C55.8496 68.1516 54.0012 70 51.7289 70H18.2711C16.2859 70 14.6248 68.5891 14.2365 66.7188C14.1805 66.448 14.1504 66.1664 14.1504 65.8793V4.1207C14.1504 1.84844 15.9988 0 18.2711 0H51.7289C54.0012 0 55.8496 1.84844 55.8496 4.1207Z"
        fill="#EDF3F7"
      />
      <path
        d="M55.8497 4.1207V65.8793C55.8497 68.1516 54.0012 70 51.7289 70H18.2711C16.286 70 14.6249 68.5891 14.2366 66.7188H47.9008C50.1772 66.7188 52.0215 64.8744 52.0215 62.598V4.1207C52.0215 1.84434 50.1772 0 47.9008 0H51.7289C54.0012 0 55.8497 1.84844 55.8497 4.1207Z"
        fill="#CAD0D4"
      />
      <path
        d="M55.8496 63.5059V65.8793C55.8496 68.1516 54.0012 70 51.7289 70H18.2711C16.2859 70 14.6248 68.5891 14.2365 66.7188C14.1805 66.448 14.1504 66.1664 14.1504 65.8793V63.5059H55.8496Z"
        fill="#676D70"
      />
      <path
        d="M45.9375 0V3.69824C45.9375 4.99844 44.8793 6.05664 43.5791 6.05664H26.4209C25.1207 6.05664 24.0625 4.99844 24.0625 3.69824V0L45.9375 0Z"
        fill="#676D70"
      />
      <path
        d="M45.9375 1.1543V3.69863C45.9375 4.99883 44.8793 6.05703 43.5791 6.05703H26.4209C25.1207 6.05703 24.0625 4.99883 24.0625 3.69863V3.32266H43.5873C44.8232 3.32266 45.8404 2.36563 45.9375 1.1543Z"
        fill="#43494D"
      />
      <path
        d="M51.9204 63.5059H55.8497V65.8793C55.8497 68.1516 54.0012 70 51.7289 70H18.2711C16.286 70 14.6249 68.5891 14.2366 66.7188H47.9008C49.8655 66.7188 51.5075 65.3447 51.9204 63.5059Z"
        fill="#43494D"
      />
      <path
        d="M46.7537 44.1851L45.783 45.8038L45.4398 46.3767C45.0898 46.97 44.5265 47.4048 43.8662 47.5935C41.68 48.1923 36.8607 48.314 29.1347 40.588C21.4101 32.862 21.5304 28.0427 22.1293 25.8565C22.3179 25.1962 22.7527 24.6315 23.3461 24.2829L23.975 23.9056L25.5377 22.9677C26.038 22.6682 26.6847 22.8145 27.0087 23.2999L30.5019 28.5403C30.8191 29.0161 30.7152 29.6559 30.264 30.0073L28.689 31.1475C28.2625 31.4757 28.1408 32.0649 28.4005 32.5352C28.9775 33.5702 29.523 34.7925 32.2246 37.4981C34.9275 40.2038 36.1525 40.7452 37.1875 41.3222C37.6578 41.5819 38.247 41.4602 38.5751 41.0337L39.7154 39.4587C40.0667 39.0075 40.7066 38.9036 41.1824 39.2208L46.4228 42.714C46.9081 43.038 47.0544 43.6847 46.7537 44.1851Z"
        fill="#92989C"
      />
      <path
        d="M46.7537 44.1851L45.783 45.8038C43.5982 46.4026 38.8459 46.4628 31.1213 38.7368C23.3953 31.0108 23.3762 26.0903 23.975 23.9056L25.5377 22.9677C26.0381 22.6682 26.6847 22.8145 27.0088 23.2999L30.5019 28.5403C30.8191 29.0161 30.7152 29.6559 30.264 30.0073L28.689 31.1475C28.2625 31.4757 28.1408 32.0649 28.4006 32.5352C28.9775 33.5702 29.523 34.7925 32.2246 37.4981C34.9275 40.2038 36.1525 40.7452 37.1875 41.3222C37.6578 41.5819 38.2471 41.4602 38.5752 41.0337L39.7154 39.4587C40.0668 39.0075 40.7066 38.9036 41.1824 39.2208L46.4228 42.714C46.9082 43.038 47.0545 43.6847 46.7537 44.1851Z"
        fill="#7F8489"
      />
      <path
        d="M34.3959 26.6797C33.8294 26.6797 33.3705 27.1388 33.3705 27.7051C33.3705 28.2714 33.8294 28.7305 34.3959 28.7305C38.0326 28.7305 40.9912 31.6891 40.9912 35.3258C40.9912 35.8921 41.4502 36.3512 42.0166 36.3512C42.583 36.3512 43.042 35.8921 43.042 35.3258C43.042 30.5583 39.1634 26.6797 34.3959 26.6797Z"
        fill="#7F8489"
      />
      <path
        d="M34.3959 20.4922C33.8294 20.4922 33.3705 20.9513 33.3705 21.5176C33.3705 22.0839 33.8294 22.543 34.3959 22.543C41.4445 22.543 47.1791 28.2775 47.1791 35.3262C47.1791 35.8925 47.638 36.3516 48.2045 36.3516C48.7709 36.3516 49.2299 35.8925 49.2299 35.3262C49.2299 27.1467 42.5753 20.4922 34.3959 20.4922Z"
        fill="#7F8489"
      />
    </g>
    <defs>
      <clipPath id="clip0_439_15926">
        <rect width="70" height="70" fill="white" />
      </clipPath>
    </defs>
  </svg>
)
